const PERMISSION_KEY= "crm:campaign_sale";
const PAGE_URL = {
    CAMPAIGN_SALE_PAGE: "/admin/crm/campaign-sale"
}

export {PERMISSION_KEY, PAGE_URL}

